/**
 * WaitingModal Component
 *
 * Modal displayed when one player is ready and waiting for the opponent.
 *
 * Features:
 * - Shows waiting animation/spinner
 * - Displays status message
 * - Shows player ready status (e.g., "1/2 players ready")
 * - Automatically dismisses when both players ready and game starts
 * - Non-closable (players must wait for opponent)
 *
 * Phase 6.2 Implementation
 */

import { COPY } from '../copy';
import GameModal from './GameModal';
import { useGameStore } from '../stores/gameStore';

export default function WaitingModal({ isOpen }) {
  const player1 = useGameStore((state) => state.player1);
  const player2 = useGameStore((state) => state.player2);

  // Count how many players are ready
  const readyCount = [player1?.ready, player2?.ready].filter(Boolean).length;
  const totalPlayers = [player1, player2].filter(Boolean).length;
  const maxPlayers = totalPlayers > 2 ? totalPlayers : 2;

  // Prepare status message
  let statusMessage = COPY.modal.waiting.waitingToReady;
  if (totalPlayers === 2 && readyCount === 1) {
    statusMessage = COPY.modal.waiting.waitingToPlay;
  } else if (totalPlayers === 1) {
    statusMessage = COPY.modal.waiting.waitingToJoin;
  }

  const readyStatusText = `${readyCount}/${maxPlayers} players ready`;

  return (
    <GameModal
      isOpen={isOpen}
      type="waiting"
      title="Waiting for Opponent"
      message={statusMessage}
      closable={false}
      onClose={null}
    >
      <div className="text-center">
        <p
          className="text-white font-semibold text-lg"
          data-testid="ready-count"
        >
          {readyStatusText}
        </p>
      </div>
    </GameModal>
  );
}
